<script lang="ts">
    import type { NewsFeedPostFragment } from '$gql/graphql.js';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import * as t from '$trans';

    const { urlHelper, lang } = getContainer();
    export let post: NewsFeedPostFragment;
</script>

{#if post.relatedCategory != null}
    <div
        class={'relative flex flex-wrap ls:flex-nowrap items-center justify-between bg-gray-100 px-4 py-2 border border-gray-300 my-2 rounded-md'}
        class:mt-6={post.medias.length > 0}
    >
        <div class={'text-gray-600 text-sm'}>
            {t.feed_post.discussion_in_category({}, $lang)}
            <a
                href={post.relatedCategoryUrl}
                class="text-gray-600 font-bold hover:underline hover:text-link"
            >
                {post.relatedCategory.category}
            </a>
        </div>
        <a
            href={urlHelper().newsfeedCategory(post.relatedCategory.id)}
            data-sveltekit-reload={false}
            class="btn btn-sm btn-leo">{t.feed_post.see_discussion({}, $lang)}</a
        >
    </div>
{/if}
